module.exports = __webpack_public_path__ + "static/media/drogaria-chacara-inglesa.15709672.png";